<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();

const isEnabled = ref(false);
const isUpdating = ref(false); // To track API request status locally if needed

watch(
  currentAccount,
  () => {
    const { agent_signature_enabled } = currentAccount.value?.settings || {};
    isEnabled.value = !!agent_signature_enabled;
  },
  { deep: true, immediate: true }
);

const toggleAgentSignature = async () => {
  try {
    isUpdating.value = true; // Optional: could show a loader or disable switch
    await updateAccount({
      agent_signature_enabled: isEnabled.value,
    });
    useAlert(t('GENERAL_SETTINGS.FORM.AGENT_SIGNATURE.API.SUCCESS'));
  } catch (error) {
    // Revert state on error
    isEnabled.value = !isEnabled.value;
    useAlert(t('GENERAL_SETTINGS.FORM.AGENT_SIGNATURE.API.ERROR'));
  } finally {
    isUpdating.value = false;
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AGENT_SIGNATURE.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AGENT_SIGNATURE.NOTE')"
    tooltip-identifier="settings_agent_signature"
    with-border
  >
    <div class="flex items-center justify-between">
      <div class="flex flex-col">
        <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
          {{ t('GENERAL_SETTINGS.FORM.AGENT_SIGNATURE.LABEL') }}
        </span>
        <span class="text-xs text-slate-600 dark:text-slate-400 mt-1">
          {{ t('GENERAL_SETTINGS.FORM.AGENT_SIGNATURE.HELP') }}
        </span>
      </div>
      <Switch v-model="isEnabled" @change="toggleAgentSignature" />
    </div>
  </SectionLayout>
</template>
